<div class="imapct-container">
  <div
    *ngIf="loss"
    class="impact-item loss"
    [ngStyle]="{ width: lossWidth + '%' }"
  >
    <div
      [ngClass]="lossWidth < 16 ? 'rounded-value' : 'value'"
      [ngStyle]="{ right: lossWidth < 16 ? '2px' : 'auto' }"
    >
      {{ loss | dollar }}
    </div>
  </div>
  <div
    *ngIf="target !== null"
    class="impact-item target"
    [ngStyle]="{ width: targetWidth + '%' }"
  >
    <div
      [matTooltip]="total | dollar"
      matTooltipPosition="right"
      style="cursor: pointer"
      [ngClass]="targetWidth < 16 ? 'rounded-value' : 'value'"
      [ngStyle]="{ left: targetWidth < 16 ? '2px' : 'auto' }"
    >
      {{ target | dollar }}
    </div>
  </div>
  <!-- [ngStyle]="{
      width: additionalWidth + '%',
      left:
        'calc(' +
        targetWidth +
        '% + 25% - ' +
        (targetWidth > 13 ? targetCharLength - targetWidth : 0) +
        'px)'
    }" -->
  <div
    *ngIf="additional"
    class="impact-item additional tooltip"
    [ngStyle]="{
      width: additionalWidth + '%',
      left: 'calc(' + targetWidth + '% + 25%)'
    }"
    matTooltipPosition="above"
  >
    <div
      [ngClass]="additionalWidth < 16 ? 'rounded-value' : 'value'"
      [ngStyle]="{
        left: (targetWidth < 16 ? targetCharLength - targetWidth : 0) + 'px'
      }"
    >
      {{ additional | dollar }}
    </div>
  </div>

  <!-- <div  class="total" title="GO TO PRICE CHANGE TRACKER">
    <div class="value">{{ total | dollar }}</div>
  </div> -->
</div>
